module.exports = __webpack_public_path__ + "static/media/nifco_logo_dark.6b89e200.png";